import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { RouterService } from '@app/routing/router.service';
import { DefaultCache } from '@app/utils/cache';
import { clearAllSubscriptionBasedRxCached } from '@app/utils/cached';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  constructor(
    private authenticationService: AuthenticationService,
    private routerService: RouterService
  ) {}

  /**
   * Clear the cache.
   */
  clearCache(): void {
    DefaultCache().clear();
  }

  /**
   * Evict all caches starting with 'end-user'.
   */
  evictUserCache() {
    DefaultCache().evictAllWithPrefix('end-user-');
  }

  /**
   * Start listening to authentication and route changes and evict the user cache if the end-user
   * leaves the end-user level.
   */
  initialize() {
    this.authenticationService.onLogout$.subscribe(() => {
      this.clearCache();
      clearAllSubscriptionBasedRxCached();
    });

    this.routerService.routeDataChange$
      .pipe(filter((routeData) => routeData.current != null && routeData.old != null))
      .subscribe((routeData) => {
        if (routeData.current.params.userId == null && routeData.old.params.userId != null) {
          this.evictUserCache();
        }
      });
  }
}
